<template>
  <v-responsive class="overflow-y-auto inherit-height">
    <v-container>
      <v-row class="employee-card-row">
        <v-col class="employee-card" v-for="(item, index) in filteredPerson" :key="index" cols="12" xs="7" sm="6" md="4" xl="3">
          <v-lazy
            v-model="isActive[index]"
            min-height="200"
            :options="{
              threshold: 0.5,
            }"
            transition="fade-transition"
          >
            <employee-card :employee="item" :photo-filename="getPhotoFilename(item)"></employee-card>
          </v-lazy>
        </v-col>
      </v-row>
    </v-container>
  </v-responsive>
</template>
<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import employeeService from '@/modules/employee/employeeService';
import EmployeeCard from '@/modules/employee/EmployeeCard.vue';

export default {
  name: 'Employee',
  mixins: [common, configMixin, dateTimeMixin],
  components: {
    EmployeeCard,
  },

  props: {
    filteredPerson: Array,
    photoByEmployeeId: Object,
  },

  data() {
    return {
      isActive: this.filteredPerson.map((item) => false),
    };
  },

  methods: {
    getPhotoFilename(item) {
      return employeeService.getPhotoFilename(this.photoByEmployeeId, item);
    },
  },
};
</script>
